import { useEffect, useState } from "preact/hooks";
import { Masthead } from "../components/Masthead";
import { idx, resolved, drawerId } from "../store";
import { active } from "../lib/state";
import { DAYS } from "../lib/planner";
import { fmt } from "../lib/text";
import { parseWeeks } from "../lib/weeks";
import { kindLabel } from "../i18n";
import type { Day } from "../lib/types";

const DAYS_BS = ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"];
const MONTHS_BS = ["januar", "februar", "mart", "april", "maj", "juni", "juli", "august", "septembar", "oktobar", "novembar", "decembar"];
const longDate = (d: Date) => `${DAYS_BS[d.getDay()]}, ${d.getDate()}. ${MONTHS_BS[d.getMonth()]}`;
const iso = (d: Date) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function Today() {
  const I = idx.value!;
  const [now, setNow] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setNow(new Date()), 30_000); return () => clearInterval(t); }, []);
  document.title = "Danas · Slušam";
  const sched = active.value;
  const { slots } = resolved.value;
  const holidays = new Map(I.core.calendar.holidays.map((h) => [h.date, h.name]));

  const target = new Date(now);
  let dIdx = (target.getDay() + 6) % 7;
  const anyOn = (d: number) => slots.some((s) => s.day === DAYS[d]);
  let label = "Danas";
  if (!anyOn(dIdx) || (dIdx === (now.getDay() + 6) % 7 && slots.filter((s) => s.day === DAYS[dIdx]).every((s) => s.end <= now.getHours() * 60 + now.getMinutes()))) {
    for (let k = 1; k <= 7; k++) { const n = (dIdx + k) % 7; if (anyOn(n)) { target.setDate(target.getDate() + k); dIdx = n; label = k === 1 ? "Sutra" : DAYS_BS[(n + 1) % 7]; break; } }
  }
  const d = DAYS[dIdx] as Day;
  const winterStart = new Date((I.units.values().next().value?.semesters.winter["1"][0] ?? "2026-10-05") + "T00:00:00");
  const week = Math.floor((+target - +winterStart) / (7 * 864e5)) + 1;
  const hol = holidays.get(iso(target));
  const mins = now.getHours() * 60 + now.getMinutes();
  const isToday = iso(target) === iso(now);
  const list = slots.filter((s) => s.day === d).filter((s) => { const w = parseWeeks(s.weeks); return !w || week < 1 || w.has(week); }).sort((a, b) => a.start - b.start);

  return (
    <>
      <Masthead compact />
      <div class="page" style="max-width:640px">
        <div class="kicker">{sched.name} · {week >= 1 && week <= 16 ? `${week}. sedmica nastave` : "van semestra"}</div>
        <h1 style="font:400 48px/1 var(--display);margin:.3rem 0 .2rem">{label}</h1>
        <p class="note">{longDate(target)}</p>
        {hol && <div class="alert warn"><b>Praznik</b>{hol}, nema nastave.</div>}
        {!slots.length && <p class="empty">Još nemate predmeta u rasporedu. <a href="/">Dodajte ih iz kataloga.</a></p>}
        <div style="display:grid;gap:.6rem;margin-top:1rem">
          {list.map((s) => {
            const live = isToday && s.start <= mins && mins < s.end;
            const past = isToday && s.end <= mins;
            const u = s.fac ? I.units.get(s.fac) : undefined;
            return (
              <div key={s.id} class="pick" style={`--bc:${s.color};${past ? "opacity:.45;" : ""}${live ? "box-shadow:4px 4px 0 var(--ink);border-color:var(--ink)" : ""}`}>
                <span class="sw" />
                <div>
                  <div class="meta"><span class="fac" style="font-size:13px">{fmt(s.start)}–{fmt(s.end)}</span>{live && <span class="badge clash">sada</span>}<span>{kindLabel(s.kind)}</span></div>
                  <h4 onClick={() => { if (s.courseId) { drawerId.value = s.courseId; location.href = `/c/${encodeURIComponent(s.courseId)}`; } }}>{s.title}</h4>
                  <div class="nosched" style="font-style:normal;font-family:var(--body)">
                    {s.room && <>sala {s.room} · </>}{u && <a href={`https://www.openstreetmap.org/?mlat=${u.lat}&mlon=${u.lng}#map=18/${u.lat}/${u.lng}`} target="_blank" rel="noopener">{u.name}</a>}
                    {s.lecturer && <> · {s.lecturer}</>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
